import { z } from "zod/v4";
import { ClientApiFeaturePathParams, defineEndpoint, defineResource } from "@visioni/a3s-client-api";
import { TriggerCommand, StopCommand } from "../g2-fleet-messages/commands";
import { FEATURE_NAME } from "../constants";

export const CommandBody = z.discriminatedUnion("action", [TriggerCommand, StopCommand]);
export type CommandBody = z.output<typeof CommandBody>;

export const CommandResponse = z.object({ success: z.boolean() });
export type CommandResponse = z.output<typeof CommandResponse>;

export type CommandPathParams = ClientApiFeaturePathParams;

export const commandsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "commands",
});

export const deterrenceCommandEndpoint = defineEndpoint(commandsResource, {
  method: "POST",
  bodySchema: CommandBody,
  responseSchema: CommandResponse,
});
